import { Link, useLocalSearchParams, usePathname } from 'expo-router';
import { useQuery } from 'urql';
import Card from '@/components/UI/Card';
import Item from '@/components/UI/PressableRow';
import Text from '@/components/UI/Text';
import { graphql } from '@/gql/graphql';
import Icon from '../Unistyles/Icon';

const GetEventUpdateDangerZone = graphql(/* GraphQL */ `
  query GetEventUpdateDangerZone($eventId: uuid!) {
    event_by_pk(id: $eventId) {
      id
      permissions
      title
    }
  }
`);

export default function EventUpdateDangerZone() {
  const { eventId } = useLocalSearchParams<{ eventId: string }>();

  const [{ data }] = useQuery({
    query: GetEventUpdateDangerZone,
    variables: { eventId: eventId || '' },
  });

  const event = data?.event_by_pk;
  const pathname = usePathname();

  return event?.permissions?.delete ? (
    <Card>
      <Link
        href={{
          pathname: `${pathname}/delete`,
          params: {
            title: event?.title,
          },
        }}
        asChild
      >
        <Item>
          <Icon name="trash-outline" />
          <Text>Delete…</Text>
        </Item>
      </Link>
    </Card>
  ) : null;
}
